// PLUGINS IMPORTS //
import React from "react"
import styled from "styled-components/macro"

// COMPONENTS IMPORTS //
import SectionItem from "./Shared/SectionItem/SectionItem"

import Features from "./Features/Features"
import Technologies from "./Technologies/Technologies"
import Video from "./Video/Video"

import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //

// REDUX
import { ProjectType } from "Redux/Types/ProjectsTypes"

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  project: ProjectType
}

const BodySection: React.FC<PropsType> = (props) => {
  const { title, description, technologies, features } = props.project

  return (
    <Wrapper>
      <div style={{ flex: 1.6 }}>
        <SectionItem title={"Description"}>{description}</SectionItem>

        {features && <Features title={title} features={features} />}
      </div>
      <div style={{ flex: 1, marginLeft: 90 }}>
        {technologies && technologies.length > 0 && (
          <Technologies technologies={technologies} />
        )}
      </div>
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const MARGIN_HORIZONTAL = "20px"
const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-right: ${MARGIN_HORIZONTAL};
  margin-left: ${MARGIN_HORIZONTAL};
  margin-top: 40px;
`

export default React.memo(BodySection, memoComparison)
